import React, { Suspense, useContext, useEffect, useState } from "react";
import {
    Button,
    Container,
    CssBaseline, Snackbar,
    TextField
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import validate from "validate.js";
import {GlobalContext} from "../../contexts/context";
import {useAuthenticateUser} from "../../hooks";
import {createBrowserHistory} from 'history';
import {Alert} from "@material-ui/lab";
const history = createBrowserHistory();
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.spacing(2)
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    container: {
        backgroundColor: theme.palette.background.default,
    },
    logo: {
        width: "200px"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const Login = () => {
    const classes = useStyles();
    const context = useContext(GlobalContext);
    const {loading: loginLoading, content: loginResult, handleAuthenticate} = useAuthenticateUser();
    const [openSuccToast, setOpenSuccToast] = useState({
        open: false,
        message: ""
    });

    const [openFailToast, setOpenFailToast] = useState({
        open: false,
        message: ""
    });

    const failToast = (message) => {
        setOpenFailToast({
            message: message,
            open: true
        });
    };

    const successToast = (message) => {
        setOpenSuccToast({
            message: message,
            open: true
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSuccToast({
            message: "",
            open: false
        });

        setOpenFailToast({
            message: "",
            open: false
        });
    };

    const [formState, setFormState] = useState({
        isValid: false,
        values: {
            username: "",
            password: "",
            clientId: ""
        },
        touched: {},
        errors: {}
    });

    const schema = {
        username: {
            presence: {allowEmpty: false, message: "is required"}
        },
        password: {
            presence: {allowEmpty: false, message: "is required"}
        },
        clientId: {
            presence: {allowEmpty: false, message: "is required"}
        }
    }

    const errors = validate(formState.values, schema);
    const hasError = (field) =>
        !!(formState.touched[field] && formState.errors[field]);

    useEffect(() => {
        setFormState(formState => ({
            ...formState,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [formState.values]);

    const handleForm = (event) => {
        event.persist();
        setFormState({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]: event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            }
        })
    }

    const handleSubmit = async () => await handleAuthenticate(formState.values)

    const handleSuccessLogin = async () => {
        await context.saveLocalState("user", {
            ...context.user,
            verified: true,
            verifiedTime: Date.now()
        });
        await context.saveLocalState("applicationState", {
            ...context.applicationState,
            logoUrl: document.getElementById("applicationLogoUrl").value !== "" &&
            document.getElementById("applicationLogoUrl").value !== null &&
            document.getElementById("applicationLogoUrl").value !== undefined ?
                document.getElementById("applicationLogoUrl").value :
                process.env.REACT_APP_LOGO_URL,
            apiUrl: document.getElementById("applicationApiUrl").value || process.env.REACT_APP_RPA_URL
        })
        window.location.href = `${window.location.origin}/dashboard`
    }

    useEffect(() => {
        if(loginResult.hasError){
            failToast(loginResult.message);
        } else if(!loginResult.hasError && loginResult.data) {
            handleSuccessLogin();
            successToast(`${loginResult.message}: Redirecting...`);
        }
    }, [loginResult])

    return (
        <Container component="main" maxWidth="xs" className={classes.container}>
            <CssBaseline />
            <div className={classes.paper}>
                <img
                    className={classes.logo}
                    alt="Logo"
                    src="/images/encompasslogo.png"/>
                <form className={classes.form} noValidate onSubmit={(e) => e.preventDefault()}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleForm}
                        value={formState.values.username}
                        helperText={hasError("username") ? formState.errors.username[0] : null}
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        onChange={handleForm}
                        value={formState.values.password}
                        helperText={hasError("password") ? formState.errors.password[0] : null}
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        onChange={handleForm}
                        value={formState.values.clientId}
                        helperText={hasError("clientId") ? formState.errors.clientId[0] : null}
                        fullWidth
                        id="clientId"
                        label="Client ID"
                        name="clientId"
                        autoComplete="clientId"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        disabled={!formState.isValid || loginLoading}
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        className={classes.submit}
                    >
                        {
                            !loginLoading &&
                            <span>Sign In</span>
                        }
                        {
                            loginLoading &&
                            <span>Loading...</span>
                        }
                    </Button>
                </form>
            </div>
            <Snackbar open={openSuccToast.open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical: 'top', horizontal:'right'}}>
                <Alert onClose={handleClose} severity="success">
                    {openSuccToast.message}
                </Alert>
            </Snackbar>
            <Snackbar open={openFailToast.open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical: 'top', horizontal:'right'}}>
                <Alert onClose={handleClose} severity="error">
                    {openFailToast.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default Login;
